import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import ObrasApi from 'Data/Obras.api';
import toastHandler from 'Utils/toastHandler';
import { FILES_QUERY_KEY } from 'Data/keys/QueryKeys';
import { IUseQueryFilesReturn } from 'Data/interfaces/ListagemArquivos/IListFiles';
import { useDispatch } from 'react-redux';
import { ICreateFolderRequest } from '../../Data/interfaces/Obra/ICreateFolder';
import { ListagemArquivosActions } from 'Store/ListagemArquivos/ListagemArquivos.actions';

export const useQueryCreateFolderFiles = () => {
  const dispatch = useDispatch();

  const { mutate, isPending } = useMutation({
    mutationFn: (variables: ICreateFolderRequest) => {
      return ObrasApi.createFolder(variables);
    },
    onSuccess: async ({ data }, variables) => {
      await queryClient.cancelQueries({
        queryKey: [
          FILES_QUERY_KEY,
          Number(variables.ConstructionSiteId),
          variables.FolderCurrentId,
        ],
      });

      queryClient.setQueryData<IUseQueryFilesReturn>(
        [
          FILES_QUERY_KEY,
          Number(variables.ConstructionSiteId),
          variables.FolderCurrentId,
        ],
        (old) => {
          if (old) {
            const newFolder = data.data;
            const newListFiles = [...old.ListFiles];
            const insertIndex = newListFiles.findIndex(
              (file) => file.IsFolder && file.Name.localeCompare(newFolder.Name) > 0,
            );
            if (insertIndex === -1) {
              const firstFileIndex = newListFiles.findIndex((file) => !file.IsFolder);
              newListFiles.splice(
                firstFileIndex === -1 ? newListFiles.length : firstFileIndex,
                0,
                newFolder,
              );
            } else {
              newListFiles.splice(insertIndex, 0, newFolder);
            }
            return { ...old, ListFiles: newListFiles };
          }
          return old;
        },
      );
      dispatch(ListagemArquivosActions.setShowModalCreateFolder(false));
    },
    onError: async (error: any) => {
      const errorMsg = error.errors ? error.errors[0].Message : 'Erro ao criar pasta';
      toastHandler.showError(errorMsg);
      dispatch(ListagemArquivosActions.setShowModalCreateFolder(false));
    },
  });

  return {
    createFolderFiles: mutate,
    isLoading: isPending,
  };
};
